const SUNDAY = 0;

const addBusinessDays = (start, days) => {
  const date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  let counted = 0;

  while (counted < days) {
    date.setDate(date.getDate() + 1);
    if (date.getDay() !== SUNDAY) counted += 1;
  }

  return date;
};

const toIsoDate = (date) =>
  [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');

class DeliveryDate extends HTMLElement {
  connectedCallback() {
    const minDays = Math.max(parseInt(this.dataset.minDays, 10), 1);
    if (Number.isNaN(minDays)) return;

    const maxDays = Math.max(parseInt(this.dataset.maxDays, 10) || 0, minDays);
    const locale = this.dataset.locale || document.documentElement.lang;
    const formatter = new Intl.DateTimeFormat(locale, { weekday: 'short', day: '2-digit', month: '2-digit' });
    const format = (date) =>
      formatter
        .formatToParts(date)
        .map((part, index, parts) =>
          part.type === 'literal' && parts[index - 1]?.type === 'weekday' ? ' ' : part.value
        )
        .join('');

    const today = new Date();
    const days = maxDays > minDays ? [minDays, maxDays] : [minDays];
    const nodes = days.flatMap((count, index) => {
      const date = addBusinessDays(today, count);
      const time = document.createElement('time');
      time.dateTime = toIsoDate(date);
      time.textContent = format(date);
      return index === 0 ? [time] : [' - ', time];
    });

    this.replaceChildren(...nodes);
  }
}

if (!customElements.get('delivery-date')) {
  customElements.define('delivery-date', DeliveryDate);
}

let refreshController;

const refreshBlocks = async () => {
  const blocks = document.querySelectorAll('[data-block-type="delivery-date"]');
  if (!blocks.length) return;

  refreshController?.abort();
  refreshController = new AbortController();

  await Promise.all(
    Array.from(blocks, async (block) => {
      const section = block.closest('.shopify-section');
      const formId = block.closest('product-rerender')?.getAttribute('observe-form');
      const variantId = formId && document.forms[formId]?.elements.id?.value;
      if (!section || !variantId) return;

      const url = new URL(window.location.pathname, window.location.origin);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));

      try {
        const response = await fetch(url, { signal: refreshController.signal });
        if (!response.ok) return;

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = html.querySelector(
          `[data-block-type="delivery-date"][data-block-id="${block.getAttribute('data-block-id')}"]`
        );
        if (fresh && block.isConnected) block.replaceWith(document.importNode(fresh, true));
      } catch (error) {
        if (error.name !== 'AbortError') throw error;
      }
    })
  );
};

document.addEventListener('cart:change', refreshBlocks);
document.addEventListener('cart:refresh', refreshBlocks);
